<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import 'vue-loading-overlay/dist/vue-loading.min.css';

export default {
  name: 'app',
};
</script>

<!-- GLOBAL SASS -->
<style lang="scss">
.notify {
  z-index: 99999!important;
  bottom: 100px!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue